import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-708d5152"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout-page" }
const _hoisted_2 = { class: "content-wrapper" }
const _hoisted_3 = { class: "px-4 flex-grow-1 container-p-y" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-8" }
const _hoisted_6 = { class: "card mb-4" }
const _hoisted_7 = { class: "d-flex align-items-end row" }
const _hoisted_8 = { class: "col-sm-7" }
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = { class: "card-title" }
const _hoisted_11 = { class: "text-primary" }
const _hoisted_12 = { class: "mb-0" }
const _hoisted_13 = { class: "mb-0" }
const _hoisted_14 = { class: "mb-0" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "javascript:;",
  class: "btn btn-sm btn-outline-primary mt-2"
}, "Free Plan", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-5 text-center text-sm-left" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-body pb-0 px-0 px-md-4" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/assets/img/illustrations/man-with-laptop-light.png",
      height: "140",
      alt: "View Badge User",
      "data-app-dark-img": "illustrations/man-with-laptop-dark.png",
      "data-app-light-img": "illustrations/man-with-laptop-light.png"
    })
  ])
], -1))
const _hoisted_17 = { class: "card mb-4" }
const _hoisted_18 = { class: "row row-bordered g-0" }
const _hoisted_19 = { class: "col-md-12" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-header m-0 me-2 pb-3" }, "Graphical Reports", -1))
const _hoisted_21 = {
  id: "incomeChart",
  class: "px-2"
}
const _hoisted_22 = { class: "card mb-4" }
const _hoisted_23 = { class: "row row-bordered g-0" }
const _hoisted_24 = { class: "col-md-12" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-header m-0 me-2 pb-3" }, "Graphical Reports", -1))
const _hoisted_26 = { id: "incomeChart" }
const _hoisted_27 = { class: "col-md-4" }
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col-lg-6 col-md-12 col-6 mb-4" }
const _hoisted_30 = { class: "card" }
const _hoisted_31 = { class: "card-body" }
const _hoisted_32 = {
  key: 0,
  class: "d-flex justify-content-center align-items-center"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = { key: 1 }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-title d-flex align-items-start justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "avatar flex-shrink-0" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/assets/img/icons/unicons/chart-success.png",
      alt: "chart success",
      class: "rounded"
    })
  ])
], -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-semibold d-block mb-1" }, "Number of Product", -1))
const _hoisted_38 = { class: "card-title mb-2" }
const _hoisted_39 = { class: "col-6 mb-4" }
const _hoisted_40 = { class: "card" }
const _hoisted_41 = { class: "card-body" }
const _hoisted_42 = {
  key: 0,
  class: "d-flex justify-content-center align-items-center"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1))
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = { key: 1 }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-title d-flex align-items-start justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "avatar flex-shrink-0" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/assets/img/icons/unicons/cc-warning.png",
      alt: "Credit Card",
      class: "rounded"
    })
  ])
], -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-semibold d-block mb-1" }, "Alert Product", -1))
const _hoisted_48 = { class: "card-title mb-2" }
const _hoisted_49 = { class: "row" }
const _hoisted_50 = { class: "col-6 mb-4 mb-4" }
const _hoisted_51 = { class: "card" }
const _hoisted_52 = { class: "card-body" }
const _hoisted_53 = {
  key: 0,
  class: "d-flex justify-content-center align-items-center"
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1))
const _hoisted_55 = [
  _hoisted_54
]
const _hoisted_56 = { key: 1 }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-title d-flex align-items-start justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "avatar flex-shrink-0" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/assets/img/icons/unicons/cube-secondary.png",
      alt: "cube",
      class: "rounded"
    })
  ])
], -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-medium d-block mb-1" }, "Orders", -1))
const _hoisted_59 = { class: "card-title mb-2" }
const _hoisted_60 = { class: "col-lg-6 col-md-12 col-6 mb-4" }
const _hoisted_61 = { class: "card" }
const _hoisted_62 = { class: "card-body" }
const _hoisted_63 = {
  key: 0,
  class: "d-flex justify-content-center align-items-center"
}
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1))
const _hoisted_65 = [
  _hoisted_64
]
const _hoisted_66 = { key: 1 }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-title d-flex align-items-start justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "avatar flex-shrink-0" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/assets/img/icons/unicons/wallet-info.png",
      alt: "Credit Card",
      class: "rounded"
    })
  ])
], -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Sales", -1))
const _hoisted_69 = { class: "card-title text-nowrap mb-1" }
const _hoisted_70 = { class: "row" }
const _hoisted_71 = { class: "col-6 mb-4" }
const _hoisted_72 = { class: "card" }
const _hoisted_73 = { class: "card-body" }
const _hoisted_74 = {
  key: 0,
  class: "d-flex justify-content-center align-items-center"
}
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1))
const _hoisted_76 = [
  _hoisted_75
]
const _hoisted_77 = { key: 1 }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-title d-flex align-items-start justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "avatar flex-shrink-0" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/assets/img/icons/unicons/paypal.png",
      alt: "Credit Card",
      class: "rounded"
    })
  ])
], -1))
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block mb-1" }, "Total Due", -1))
const _hoisted_80 = { class: "card-title text-nowrap mb-2" }
const _hoisted_81 = { class: "col-6 mb-4" }
const _hoisted_82 = { class: "card" }
const _hoisted_83 = { class: "card-body" }
const _hoisted_84 = {
  key: 0,
  class: "d-flex justify-content-center align-items-center"
}
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1))
const _hoisted_86 = [
  _hoisted_85
]
const _hoisted_87 = { key: 1 }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-title d-flex align-items-start justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "avatar flex-shrink-0" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/assets/img/icons/unicons/cc-primary.png",
      alt: "Credit Card",
      class: "rounded"
    })
  ])
], -1))
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-semibold d-block mb-1" }, "Total Payment", -1))
const _hoisted_90 = { class: "card-title mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Topbar = _resolveComponent("Topbar")!
  const _component_apexchart = _resolveComponent("apexchart")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Topbar),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("h5", _hoisted_10, [
                      _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.userData.firstname) + " " + _toDisplayString(_ctx.userData.lastname), 1)
                    ]),
                    _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.userData.email), 1),
                    _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.userData.phone), 1),
                    _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.userData.address), 1),
                    _hoisted_15
                  ])
                ]),
                _hoisted_16
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_apexchart, {
                      type: "area",
                      height: "350",
                      options: _ctx.chartOptions,
                      series: _ctx.series
                    }, null, 8, ["options", "series"])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createElementVNode("div", _hoisted_26, [
                    _createVNode(_component_apexchart, {
                      type: "line",
                      height: "350",
                      options: _ctx.chartOptions2,
                      series: _ctx.series2
                    }, null, 8, ["options", "series"])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    (_ctx.loading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, _hoisted_34))
                      : (_openBlock(), _createElementBlock("div", _hoisted_35, [
                          _hoisted_36,
                          _hoisted_37,
                          _createElementVNode("h3", _hoisted_38, _toDisplayString(_ctx.fettchDataArray.total_product), 1)
                        ]))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    (_ctx.loading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_42, _hoisted_44))
                      : (_openBlock(), _createElementBlock("div", _hoisted_45, [
                          _hoisted_46,
                          _hoisted_47,
                          _createElementVNode("h3", _hoisted_48, _toDisplayString(_ctx.fettchDataArray.alertProductList), 1)
                        ]))
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("div", _hoisted_52, [
                    (_ctx.loading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_53, _hoisted_55))
                      : (_openBlock(), _createElementBlock("div", _hoisted_56, [
                          _hoisted_57,
                          _hoisted_58,
                          _createElementVNode("h3", _hoisted_59, _toDisplayString(_ctx.fettchDataArray.totalOrderCount), 1)
                        ]))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("div", _hoisted_62, [
                    (_ctx.loading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_63, _hoisted_65))
                      : (_openBlock(), _createElementBlock("div", _hoisted_66, [
                          _hoisted_67,
                          _hoisted_68,
                          _createElementVNode("h3", _hoisted_69, _toDisplayString(_ctx.fettchDataArray.totalSaleCountSum), 1)
                        ]))
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_70, [
              _createElementVNode("div", _hoisted_71, [
                _createElementVNode("div", _hoisted_72, [
                  _createElementVNode("div", _hoisted_73, [
                    (_ctx.loading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_74, _hoisted_76))
                      : (_openBlock(), _createElementBlock("div", _hoisted_77, [
                          _hoisted_78,
                          _hoisted_79,
                          _createElementVNode("h3", _hoisted_80, _toDisplayString(_ctx.fettchDataArray.totalDueCountSum), 1)
                        ]))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_81, [
                _createElementVNode("div", _hoisted_82, [
                  _createElementVNode("div", _hoisted_83, [
                    (_ctx.loading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_84, _hoisted_86))
                      : (_openBlock(), _createElementBlock("div", _hoisted_87, [
                          _hoisted_88,
                          _hoisted_89,
                          _createElementVNode("h3", _hoisted_90, _toDisplayString(_ctx.fettchDataArray.totalPaymentCountSum), 1)
                        ]))
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode(_component_Footer)
    ])
  ]))
}